const TrashIcon = () => (
     <center> 
	<div style={{ width: 115, height: 115 }}>
		<svg xmlns="http://www.w3.org/2000/svg" width="115" height="115" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2-icon lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>

		<style jsx>{`
			#trash-group {
				transform-origin: center;
				animation: pulse 0.4s ease-in-out 1.05s both;
			}

			#circle {
				transform: scale(0);
				transform-origin: center;
				animation: pop-in 0.3s ease-out forwards;
			}

			#trash line,
			#trash polyline {
				stroke-dasharray: 60;
				stroke-dashoffset: 60;
				animation: draw-trash 0.4s ease-out forwards;
				animation-delay: 0.5s;
			}

			@keyframes pop-in {
				0% {
					transform: scale(0);
				}
				100% {
					transform: scale(1);
				}
			}

			@keyframes draw-trash {
				to {
					stroke-dashoffset: 0;
				}
			}

			@keyframes pulse {
				0% {
					transform: scale(1);
				}
				50% {
					transform: scale(1.08);
				}
				100% {
					transform: scale(1);
				}
			}
		`}</style>
	</div>
</center>
);

export default TrashIcon;